import {
  receiveFetchActivities,
  failureFetchActivities,
  requestFetchActivities,
  receiveLogExternalWorkout,
  failureLogExternalWorkout,
  receiveUpdateExternalWorkout,
  failureUpdateExternalWorkout,
} from 'actions/activities';
import { hideModal } from 'actions/modal';
import {
  ActionType,
  Activity,
  ActivityResponse,
  LogExternalWorkoutPayload,
  UpdateExternalWorkoutPayload,
} from 'reducers/activities/types';
import { getUser } from 'reducers/user';
import moment from 'moment';
import { put, call, select } from 'redux-saga/effects';
import api from '../utils/api';

const errorMessage = (error: unknown) => {
  const response = (error as { response?: { data?: { message?: unknown } } })?.response;
  return typeof response?.data?.message === 'string'
    ? response.data.message
    : 'Something went wrong. Please try again.';
};

export default function* fetchActivities(action: ActionType) {
  try {
    const { payload } = action;
    const { search = '', limit = 10, offset = 0, programId } = payload || {};
    const { cookies } = yield select(getUser);

    const { data }: { data?: ActivityResponse } = yield call(api(cookies).get, `/activities/`, {
      params: {
        search,
        limit,
        offset,
        // Upcoming scheduled days are computed in the user's calendar, not the server's
        today: moment().format('YYYY-MM-DD'),
        ...(programId ? { programId } : {}),
      },
    });

    yield put(receiveFetchActivities({ search, offset, limit, programId, data }));
  } catch (error) {
    yield put(failureFetchActivities());
  }
}

export function* logExternalWorkout(action: { type: string; payload: LogExternalWorkoutPayload }) {
  try {
    const { workoutType, timeLength, tagIds, rating, completedAt, ponder, file } =
      action.payload || {};
    const { cookies } = yield select(getUser);

    let picture: string | undefined;

    if (file) {
      const { data } = yield call(api(cookies).post, '/file', file, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });

      picture = data.fileName;
    }

    yield call(api(cookies).post, '/activities/external', {
      workoutType,
      timeLength,
      rating,
      ...(tagIds?.length ? { tagIds } : {}),
      ...(completedAt ? { completedAt } : {}),
      ...(ponder ? { ponder } : {}),
      ...(picture ? { picture } : {}),
    });

    yield put(receiveLogExternalWorkout());
    yield put(hideModal());
    // Reload the feed so the new workout shows up right away
    yield put(requestFetchActivities({}));
  } catch (error) {
    yield put(failureLogExternalWorkout(errorMessage(error)));
  }
}

export function* updateExternalWorkout(action: {
  type: string;
  payload: UpdateExternalWorkoutPayload;
}) {
  try {
    const { id, file, removePicture, ...fields } = action.payload;
    const { cookies } = yield select(getUser);

    let picture: string | null | undefined = removePicture ? null : undefined;

    if (file) {
      const { data } = yield call(api(cookies).post, '/file', file, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });

      picture = data.fileName;
    }

    const { data }: { data: Activity } = yield call(
      api(cookies).patch,
      `/activities/external/${id}`,
      {
        ...fields,
        ...(picture !== undefined ? { picture } : {}),
      },
    );

    yield put(receiveUpdateExternalWorkout(data));
  } catch (error) {
    yield put(failureUpdateExternalWorkout(errorMessage(error)));
  }
}
